<div [ngClass]="getDeliveryClasses()">
  <ion-header class="delivery-header" [ngClass]="{'device': isDevicePlatform}">
    <pptl-unread-btn></pptl-unread-btn>
    <ion-row class="row-header"></ion-row>
  </ion-header>
  <div class="delivery-container">
    <ion-content class="ion-content" #deliveryList>
      <ion-refresher slot="fixed" (ionRefresh)="ionRefresh($event)">
        <ion-refresher-content
          refreshingSpinner="circles"
          refreshingText="Refreshing...">
        </ion-refresher-content>
      </ion-refresher>
      <ion-row class="ion-row">
        <ion-col size="2" size-xs="4" size-sm="4" size-md="3"
          *ngFor="let delivery of deliveries;trackBy: trackByDeliveryKeyCode"
          [ngClass]="{'visited': delivery?.openedDelivery}"
          class="delivery-card">

          <div (click)="goToDelivery($event, delivery)"
            class="delivery-item"
            [ngClass]="delivery.offlineStatus">

            <div [ngStyle]="{'background-image': 'url(' + getDeliveryImage(delivery) + ')'}"
              class="delivery-image">
              <div class="delivery-buttons">
                <ion-buttons>
                  <pptl-reactivate-btn *ngIf="delivery.expired" [delivery]="delivery"></pptl-reactivate-btn>
                  <pptl-download-btn
                    *ngIf="isDevicePlatform"
                    [downloadConf]="downloadConf$|async"
                    [delivery]='delivery'>
                  </pptl-download-btn>
                  <pptl-favorite-btn
                    *ngIf="!isOffline"
                    [delivery]='delivery'>
                  </pptl-favorite-btn>
                </ion-buttons>
              </div>
            </div>

            <div class="flexbox">
              <div class="delivery-title ellipsis">{{delivery.campaignName | titlecase}}</div>
              <div class="tooltip">{{delivery.campaignName | titlecase}}</div>
              <div class="delivery-date">
                <div *ngIf="delivery?.releaseDate">REL: {{convertDate(delivery.releaseDate)}}</div>
                <div *ngIf="delivery?.expiryDate">EXP: {{convertDate(delivery.expiryDate)}}</div>
              </div>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <div class="infinity-scroll" *ngIf="showInfinityScroll()">
        <ion-infinite-scroll threshold="100px" (ionInfinite)="onScroll($event)">
          <ion-infinite-scroll-content
            loadingSpinner="bubbles"
            loadingText="Loading more data...">
          </ion-infinite-scroll-content>
        </ion-infinite-scroll>
      </div>
    </ion-content>
  </div>
</div>
